// extracted by mini-css-extract-plugin
export default {"container":"ExternalClientAccessInfo_container__4AzBN"};